import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { Avatar, Box, Grid, Stack, Typography } from "@mui/material";
import MainCard from "../../../../../utils/ui-components/MainCard";
import { formatMobile } from "../../../../../utils/utils";

const CardWrapper = styled(MainCard)(({ theme, color }: any) => ({
  backgroundColor: theme.palette[color].dark,
  color: "#fff",
  overflow: "hidden",
  position: "relative",
  "&:after": {
    content: '""',
    position: "absolute",
    width: 210,
    height: 210,
    background: theme.palette[color][800],
    borderRadius: "50%",
    top: -85,
    right: -95,
    [theme.breakpoints.down("sm")]: {
      top: -105,
      right: -140,
    },
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: 210,
    height: 210,
    background: theme.palette[color][800],
    borderRadius: "50%",
    top: -125,
    right: -15,
    opacity: 0.5,
    [theme.breakpoints.down("sm")]: {
      top: -155,
      right: -70,
    },
  },
}));

PendingUserInfoCard.propTypes = {
  data: PropTypes.object.isRequired,
  industry: PropTypes.array.isRequired,
  accounts: PropTypes.array.isRequired,
  color: PropTypes.string,
};

function PendingUserInfoCard({ data, color, industry, accounts }: any) {
  return (
    <CardWrapper color={color} border={false} content={false}>
      <Box sx={{ p: 2.25 }}>
        <Grid container direction="row">
          <Grid
            item
            lg={9}
            md={10}
            sm={8}
            xs={7}
            style={{
              inlineSize: "100%",
              overflowWrap: "break-word",
            }}
          >
            <Box height={"100%"} sx={{ ml: 3 }} display="flex" alignItems="center" mb={7}>
              <Grid container rowSpacing={2}>
                <Grid item lg={2.5} md={2.5} sm={5} xs={12}>
                  <Typography>Company Name</Typography>
                </Grid>
                <Grid item lg={3.5} md={3.5} sm={7} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 550,
                      opacity: 0.5,
                    }}
                  >
                    {data?.companyName}
                  </Typography>
                </Grid>
                <Grid item lg={2.5} md={2.5} sm={5} xs={12}>
                  <Typography>Username</Typography>
                </Grid>
                <Grid item lg={3.5} md={3.5} sm={7} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 550,
                      opacity: 0.5,
                    }}
                  >
                    {data?.username}
                  </Typography>
                </Grid>
                <Grid item lg={2.5} md={2.5} sm={5} xs={12}>
                  <Typography>Mobile</Typography>
                </Grid>
                <Grid item lg={3.5} md={3.5} sm={7} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 550,
                      opacity: 0.5,
                    }}
                  >
                    {formatMobile(data?.companyContact)}
                  </Typography>
                </Grid>
                <Grid item lg={2.5} md={2.5} sm={5} xs={12}>
                  <Typography>Email</Typography>
                </Grid>
                <Grid item lg={3.5} md={3.5} sm={7} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 550,
                      opacity: 0.5,
                    }}
                  >
                    {data?.email}
                  </Typography>
                </Grid>
                <Grid item lg={2.5} md={2.5} sm={5} xs={12}>
                  <Typography>Industry Type</Typography>
                </Grid>
                <Grid item lg={3.5} md={3.5} sm={7} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 550,
                      opacity: 0.5,
                    }}
                  >
                    {industry.find((o: any) => o?.value === data?.industryType)?.label}
                  </Typography>
                </Grid>
                <Grid item lg={2.5} md={2.5} sm={5} xs={12}>
                  <Typography>Account Type</Typography>
                </Grid>
                <Grid item lg={3.5} md={3.5} sm={7} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 550,
                      opacity: 0.5,
                    }}
                  >
                    {accounts.find((o: any) => o?.value === data?.accountType)?.label}
                  </Typography>
                </Grid>
                <Grid item lg={2.5} md={2.5} sm={5} xs={12}>
                  <Typography>Representative Name</Typography>
                </Grid>
                <Grid item lg={3.5} md={3.5} sm={7} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 550,
                      opacity: 0.5,
                    }}
                  >
                    {data?.representativeName}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item lg={3} md={2} sm={4} xs={5} style={{ zIndex: 1 }}>
            <Box sx={{ pt: 5, zIndex: 1 }}>
              <Stack alignItems="flex-end" sx={{ pr: 3 }}>
                <Avatar src={`${process.env.REACT_APP_API_PROD}/${data?.profileImage}`} sx={{ width: 160, height: 160 }} />
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </CardWrapper>
  );
}

export default PendingUserInfoCard;
